import React from 'react';
import { ClockIcon, FilmIcon, HelpCircleIcon, MapIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { problems } from '../data/content';
const ICONS = [FilmIcon, HelpCircleIcon, MapIcon, ClockIcon];
export function ProblemSection() {
  return <section aria-labelledby="problema" className="bg-ice-light text-navy" data-id="element-127" data-mp="30j0vten9sx7b">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-128" data-mp="2vp6c4b7o0i88">
        <p className="inline-block rounded-md bg-cta px-2 py-0.5 font-sub text-sm font-semibold text-white" data-id="element-129" data-mp="39guq6k1h5gru">
          ¿Te suena familiar?
        </p>
        <h2 id="problema" className="mt-2 font-display text-[1.4rem] font-extrabold leading-[1.15] tracking-tight sm:text-3xl" data-id="element-130" data-mp="35in9tqaxahh6">
          Quieres aprender a diagnosticar y reparar aire acondicionado
          automotriz,{' '}
          <span className="bg-cta-light px-1 text-cta" data-id="element-131" data-mp="1p2u22wpqa1kc">
            pero no sabes por dónde empezar.
          </span>
        </h2>
        <p className="mx-auto mt-2 max-w-xl text-sm leading-snug text-slate-600" data-id="element-132" data-mp="1k52dabkdqvkd">
          Si estás comenzando desde cero o quieres agregar este servicio a lo que
          ya haces, probablemente conozcas alguna de estas situaciones:
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-133" data-mp="sdjllhxwqqow">
          {problems.map((problem, i) => {
          const Icon = ICONS[i];
          return <Reveal key={problem.title} as="li" delay={i * 0.03} className="flex h-full gap-2.5 rounded-xl border-2 border-navy bg-white p-2.5 text-left" data-id="element-134" data-mp="x6cvek88gp7u" data-mpi={i}>
                <span className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg bg-cta text-white" aria-hidden="true" data-id="element-135" data-mp="1c1j1t8b8qq1p">
                  <Icon size={16} data-id="element-136" data-mp="3dtnlxxmi0j1v" />
                </span>
                <div data-id="element-137" data-mp="3dv8l60jrcq62">
                  <h3 className="font-sub text-sm font-semibold leading-tight" data-id="element-138" data-mp="3huhbswji47xe">
                    {problem.title}
                  </h3>
                  <p className="mt-0.5 text-xs leading-snug text-slate-600 sm:text-sm" data-id="element-139" data-mp="p11z23jrcpl2">
                    {problem.desc}
                  </p>
                </div>
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}